import { Inject, Pipe, PipeTransform } from '@angular/core'
import _ from 'lodash'
import { AuthContextStorageService } from '../../../core/auth/auth-context-storage.service'
import { SelectedDepartmentService } from '../../services/selected-department.service'
import { ProjectService } from '../../auth/project.service'


@Pipe({
    name: 'menuConditions',
    standalone: false
})
export class MenuConditionsPipe implements PipeTransform {

    constructor(@Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService,
                @Inject(SelectedDepartmentService) private selectedDepartmentService: SelectedDepartmentService,
                @Inject(ProjectService) private projectservice: ProjectService,
                ) {
    }

    transform(value: any): any[] {
        const result = []

        if (_.isArray(value)) {
            _.forEach(value, v => {
                if (v.text) {
                    switch (v.text) {
                        case 'Podpachtovní smlouvy':
                            if (this.authContextStorageService.hasPermission('subcontract')) {
                                result.push(v)
                            }
                            break
                        case 'Platby':
                            if (this.projectservice.isContractPayment() || this.projectservice.isContractPaymentIncoming()) {
                                result.push(v)
                            }
                            break
                        case 'Směny užívání':
                            if (this.authContextStorageService.hasPermission('barter')) {
                                result.push(v)
                            }
                            break
                        case 'Nákupy půdy':
                            if (this.authContextStorageService.hasPermission('purchase')) {
                                result.push(v)
                            }
                            break
                        case 'Daňová přiznání':
                            if (!this.selectedDepartmentService.isDepartmentSelected() && this.projectservice.isAllowTaxes()) {
                                result.push(v)
                            }
                            break
                        case 'Šablony dokumentů':
                            if (this.authContextStorageService.hasPermission('template')) {
                                result.push(v)
                            }
                            break
                        case 'Administrace':
                            if (this.authContextStorageService.isUserAdmin()) {
                                result.push(v)
                            }
                            break
                        case 'Smlouvy mimo data katastru':
                            if (this.projectservice.isNonCadastralData()) {
                                result.push(v)
                            }
                            break
                        default:
                            result.push(v)
                            break
                    }
                }
            })
        }

        return result
    }
}